// import axios from "axios";
import axiosInstance from "../../utils/axiosConfig";
import * as actionTypes from "./actionTypes";


export const apiStart = () => {
  return {
    type: actionTypes.API_START
  };
};

export const apiComplete = ()=> {
  return {
    type: actionTypes.API_COMPLETE
  };
}
export const apiFail = error => {
  return {
    type: actionTypes.API_FAIL,
    error: error
  };
};


/* export const hotelGet = () => {
    return async dispatch => {
      dispatch(apiStart());
      const headers = {
        "Content-Type": "application/json",
      };
      try {
        const response = await axiosInstance.get("/api/hotels", null,  { headers: headers });
        dispatch(hotelGetSuccess(response.data));
        
        return true;
      }
      catch (err) {
  
        if(err.response){
          const errors = err.response.data.errors;
          if (errors) {
            errors.forEach(error => message.error(error.msg));
          }
          dispatch(apiFail(err.response.data));
        }else {
          message.error(err.message)
          dispatch(apiFail(err.message));
        }
        
        
        return false;
      }
    }
  } */